import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Globe, Leaf, Shield, MessageSquare } from 'lucide-react';
import PageHeader from './PageHeader';
import SpotlightCard from './SpotlightCard';
import BrandMark from './BrandMark';
import './Commitment.css';

const Commitment = () => {
  const commitments = [
    {
      title: 'Protocolos de Saúde',
      description: 'Seguindo as melhores práticas e protocolos da saúde, nossos profissionais administrativos e técnicos internos, estão trabalhando em Home Office.',
      icon: Heart
    },
    {
      title: 'Responsabilidade Social',
      description: 'Apoio a Cruz Vermelha com atendimento de call center para agendamento e entrega de cestas básicas em São Sebastião.',
      icon: Globe
    },
    {
      title: 'Sustentabilidade',
      description: <><BrandMark /> Tecnologia busca sempre soluções que agreguem valor a um custo justo, considerando o impacto ambiental e social.</>,
      icon: Leaf
    }
  ];

  const values = [
    {
      name: 'Saúde em Primeiro Lugar',
      text: 'Priorizamos a saúde e segurança de nossos colaboradores e clientes',
      icon: Shield
    },
    {
      name: 'Responsabilidade Social',
      text: 'Contribuímos ativamente para o bem-estar das comunidades onde atuamos',
      icon: Heart
    },
    {
      name: 'Sustentabilidade',
      text: 'Buscamos soluções que respeitam o meio ambiente',
      icon: Leaf
    },
    {
      name: 'Transparência',
      text: 'Mantemos comunicação clara e transparente com todos os stakeholders',
      icon: MessageSquare
    }
  ];

  return (
    <>
      <PageHeader
        title="Nosso Compromisso"
        subtitle="Saúde, Responsabilidade Social e Sustentabilidade são pilares da nossa atuação."
        breadcrumb="Compromisso"
      />

      <section className="commitment section">
        <div className="container">
          <motion.div
            className="commitment-intro"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p className="intro-text">
              Na <BrandMark />, acreditamos que o sucesso empresarial deve andar lado a lado com o cuidado com as pessoas
              e o meio ambiente. Nossos protocolos e ações refletem esse compromisso.
            </p>
          </motion.div>

          <div className="commitments-grid">
            {commitments.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <SpotlightCard className="h-full" spotlightColor="rgba(220, 38, 38, 0.05)">
                  <div className="commitment-card-inner">
                    <div className="commitment-icon-box">
                      <item.icon size={32} />
                    </div>
                    <h3 className="commitment-card-title">{item.title}</h3>
                    <p className="commitment-card-description">{item.description}</p>
                  </div>
                </SpotlightCard>
              </motion.div>
            ))}
          </div>

          <motion.div
            className="commitment-values"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="text-center mb-10">
              <h3 className="section-title-sm">Nossos Valores</h3>
            </div>

            <div className="values-grid">
              {values.map((value, index) => (
                <div key={index} className="value-item">
                  <div className="value-icon-wrapper">
                    <value.icon size={24} />
                  </div>
                  <div>
                    <h4 className="value-name">{value.name}</h4>
                    <p className="value-text">{value.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default Commitment;

